var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
import { useDrag, useDrop } from "react-dnd";
import { contrastText } from "./color";
import { FORMATION_DRAG_TYPE, } from "./types";
var GK_COLOUR = "#22c55e";
var EMPTY_BG = "rgba(15, 23, 42, 0.55)";
var EMPTY_BORDER = "rgba(255, 255, 255, 0.55)";
export var PitchSlot = function (_a) {
    var _b;
    var slot = _a.slot, player = _a.player, primaryColour = _a.primaryColour, onDrop = _a.onDrop, _c = _a.isSelected, isSelected = _c === void 0 ? false : _c, onClick = _a.onClick;
    var isGK = slot.band === "GK";
    var shirtColour = isGK ? GK_COLOUR : primaryColour;
    var bgColour = player ? shirtColour : EMPTY_BG;
    var positionTextColour = player ? contrastText(shirtColour) : "#ffffff";
    var _d = __read(useDrag(function () { return ({
        type: FORMATION_DRAG_TYPE,
        item: player
            ? { source: "pitch", player: player, slotId: slot.id }
            : {},
        canDrag: !!player,
        collect: function (monitor) { return ({ isDragging: monitor.isDragging() }); },
    }); }, [player, slot.id]), 2), isDragging = _d[0].isDragging, dragRef = _d[1];
    var _e = __read(useDrop(function () { return ({
        accept: FORMATION_DRAG_TYPE,
        canDrop: function (item) { return !(item.source === "pitch" && item.slotId === slot.id); },
        drop: function (item) {
            onDrop(item, slot.id);
        },
        collect: function (monitor) { return ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }); },
    }); }, [slot.id, onDrop]), 2), _f = _e[0], isOver = _f.isOver, canDrop = _f.canDrop, dropRef = _e[1];
    var setRefs = function (node) {
        dragRef(node);
        dropRef(node);
    };
    var isHighlighted = isOver && canDrop;
    return (_jsxs(Box, { ref: setRefs, "data-testid": "pitch-slot-".concat(slot.id), role: "button", tabIndex: 0, "aria-pressed": isSelected, "aria-label": player
            ? "".concat(slot.label, ": #").concat((_b = player.squadNumber) !== null && _b !== void 0 ? _b : "?", " ").concat(player.lastName)
            : "".concat(slot.label, " empty slot"), onClick: function (e) {
            e.stopPropagation();
            onClick === null || onClick === void 0 ? void 0 : onClick(slot.id, player);
        }, sx: {
            position: "absolute",
            left: "".concat(slot.x, "%"),
            top: "".concat(slot.y, "%"),
            transform: "translate(-50%, -50%)",
            width: "18%",
            aspectRatio: "1",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: player ? "grab" : "pointer",
            opacity: isDragging ? 0.3 : 1,
            userSelect: "none",
            // Invisible hit-extender — the visible circle is the inner box.
            backgroundColor: "transparent",
        }, children: [_jsx(Box, { sx: {
                    width: "61%",
                    aspectRatio: "1",
                    borderRadius: "50%",
                    backgroundColor: bgColour,
                    border: "2px solid ".concat(EMPTY_BORDER),
                    boxShadow: isHighlighted
                        ? "0 0 0 4px rgba(255,255,255,0.85)"
                        : isSelected
                            ? "0 0 0 4px ".concat(primaryColour, ", 0 0 0 6px rgba(255,255,255,0.95)")
                            : "0 1px 4px rgba(0,0,0,0.45)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: positionTextColour,
                    transition: "box-shadow 0.1s ease",
                }, children: _jsx(Typography, { sx: {
                        fontSize: "min(1.9vw, 11px)",
                        fontWeight: 800,
                        letterSpacing: 0.5,
                        lineHeight: 1,
                    }, children: slot.label }) }), player && (_jsx(Typography, { sx: {
                    position: "absolute",
                    top: "100%",
                    left: "50%",
                    transform: "translate(-50%, -25%)",
                    color: "#ffffff",
                    fontSize: "clamp(11px, 2.4vw, 15px)",
                    fontWeight: 700,
                    // Translucent black pill so the name reads cleanly when it
                    // overlaps pitch markings (penalty boxes, halfway line, etc.).
                    backgroundColor: "rgba(0, 0, 0, 0.55)",
                    px: 0.75,
                    py: 0.125,
                    borderRadius: 0.75,
                    textShadow: "0 1px 2px rgba(0,0,0,0.85)",
                    whiteSpace: "nowrap",
                    pointerEvents: "none",
                    letterSpacing: 0.2,
                }, children: player.lastName }))] }));
};
